"use strict";

exports.__esModule = true;
exports.default = void 0;
var POSITIONS = /*#__PURE__*/function (POSITIONS) {
  POSITIONS["RIGHT"] = "right";
  POSITIONS["LEFT"] = "left";
  return POSITIONS;
}(POSITIONS || {});
var _default = POSITIONS;
exports.default = _default;